export default __webpack_public_path__ + "static/media/messi_banner_highlight.43a9ab08.png";